export const modifierList = [
  'rounded',
  'full',
  'label',
  'label-thin',
  'label-date',
  'text',
  'text-short',
  'text-medium',
  'title',
  'title-medium',
  'title-full',
  'cta',
  'cta-big',
  'dropdown',
];
